import React from 'react';
import styled, { css } from 'styled-components';
import { rgba } from 'polished';
import { Menu as AntdMenu } from 'antd';
import { NavLink } from 'react-router-dom';

import * as Colors from '../../attrs/colors';
import MQ from '../../attrs/mq';

export const Container = styled.div`
  display: none;

  ${MQ.lg`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 2rem;
  `}
`;

export const Menu = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const MenuItem = styled.li`
  display: inline-block;
  margin-right: 1rem;

  :last-child {
    margin-right: 0;
  }
`;

export const Sup = styled.span`
  font-size: 0.7rem;
  color: ${Colors.RED};
  vertical-align: super;
`;

const link = `
  font-size: 0.9rem;
  text-decoration: none;
  color: ${Colors.BLACK};
  display: inline-block;
  padding: .5em .25em;
  border-bottom: 1px solid transparent;
  opacity: 0.7;
  font-weight: bold;
  transition: opacity .2s ease-in-out, border-color .2s ease-in-out;

  &:hover {
    opacity: 0.85;
    color: ${Colors.BLACK};
    border-bottom-color: ${rgba(Colors.BLACK, 0.4)};
  }

  &.active {
    opacity: 1;
    color: ${Colors.BLACK};
    border-bottom-color: ${Colors.BLACK};
  }
`;

const linkSubtle = `
  font-size: 0.9rem;
  text-decoration: none;
  color: ${Colors.BLACK};
  display: inline-block;
  padding: .3em .25em;
  border-bottom: 1px solid transparent;
  opacity: 0.7;
  font-weight: bold;
  transition: opacity .2s ease-in-out, border-color .2s ease-in-out;

  &:hover {
    opacity: 0.85;
    color: ${Colors.BLACK};
    border-bottom-color: ${rgba(Colors.BLACK, 0.4)};
  }

  &.active {
    opacity: 1;
    border-bottom-color: ${Colors.BLACK};
  }
`;

// https://github.com/styled-components/styled-components/issues/1198#issuecomment-425650423
export const MenuNavLink = styled(({ subtle, ...props }) => <NavLink {...props} />)`
  ${(props) => !props.subtle && link};
  ${(props) => props.subtle && linkSubtle};
`;

export const MenuLink = styled.a`
  ${(props) => !props.subtle && link};
  ${(props) => props.subtle && linkSubtle};
`;

export const MenuNavButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  outline: none;
  ${(props) => !props.subtle && link};
  ${(props) => props.subtle && linkSubtle};

  ${(props) =>
    props.active &&
    css`
      opacity: 1;
      border-bottom-color: ${Colors.BLACK};
    `}
`;

export const DropdownMenu = styled(AntdMenu)`
  padding: 10px 4px;
`;

export const DropdownMenuItem = styled(AntdMenu.Item)`
  font-size: 1.1em;
`;
